export const REGEX = {
  NUMERIC: /^(0|[1-9][0-9]*)$/,
  NUMERIC_WITHOUT_ZERO_VALIDATION: /^(\d*)$/,
  ALPHANUMERIC: /^([a-zA-Z0-9]*)$/,
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/,
  EMAIL: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
};
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const rfc5322EmailRegex =
  /^((?:[A-Za-z0-9!#$%&'*+\-\/=?^_`{|}~]|(?<=^|\.)"|"(?=$|\.|@)|(?<=".*)[ .](?=.*")|(?<!\.)\.){1,64})(@)((?:[A-Za-z0-9.\-])*(?:[A-Za-z0-9])\.(?:[A-Za-z0-9]){2,63})$/;
export const atleast1SpecialChar = /[!@#$%^&*(),.?":{}|<>]/;
export const atleast1UpperCase = /[A-Z]/;
export const atleast1LowerCase = /[a-z]/;
export const atleast1Number = /[0-9]/;
export const noSpacesAllowed = /^\S*$/;
export const noNumbersAllowed = /^[^0-9]*$/;
export const onlyAlphanumeric = /^[a-zA-Z0-9]*$/;
export const onlyAlphanumericWithSpaces = /^[a-zA-Z0-9\s]*$/;
export const noLeadingTrailingSpaces = /^(?!\s)(?!.*\s$).*$/;
export const noSpecialCharacters = /^[a-zA-Z0-9\s]*$/;
export const noSpecialCharacterExceptComma = /^[a-zA-Z0-9\s,]*$/;
export const min8Characters = /^.{8,}$/;

